import { render, staticRenderFns } from "./priceTrend.vue?vue&type=template&id=461bf642&scoped=true"
import script from "./priceTrend.vue?vue&type=script&lang=js"
export * from "./priceTrend.vue?vue&type=script&lang=js"
import style0 from "./priceTrend.vue?vue&type=style&index=0&id=461bf642&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461bf642",
  null
  
)

export default component.exports